export default "__VITE_ASSET__4f696ec2__"